export default __webpack_public_path__ + "static/media/BannersWeb_promo_abril_gmm_330x330.5cbd2d47.png";